var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.props.value.length)?_c('div',{staticClass:"c-anexos"},_vm._l((_setup.props.value),function(anexo,index){return _c('a',{key:anexo?.name || index,staticClass:"c-anexos__anexo",on:{"click":function($event){return _setup.abreAnexo(anexo)}}},[_vm._v(" • Anexo "+_vm._s(index + 1)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }